import { TableColumn } from '@app/shared/components/data-table/data-table.component';
import { FormFieldConfig } from '@shared/components/search-form/search-form.component';

// ============================================================================
// INTERFACES
// ============================================================================

/** Mirrors goods-service's GoodsSyncLogVO (RBA-2266 / RBA-3104 / RBA-3105). */
export interface SyncLogItem {
  id: number;
  eventType?: string;
  schemaVersion?: string;
  entityType: string;
  entityId: number;
  operation: string;
  trigger: string;
  result: string;
  errorReason?: string;
  errorType?: string;
  durationMs?: number;
  occurredAt: string;
  createdBy?: string;
}

export interface SyncErrorReportSearchParams {
  eventType?: string;
  schemaVersion?: string;
  result?: string;
  entityType?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
}

// ============================================================================
// FILTER OPTIONS
// ============================================================================

export const SYNC_REPORT_ENTITY_TYPE_OPTIONS = [
  { label: 'sync_report.entity_types.category', value: 'CATEGORY' },
  { label: 'sync_report.entity_types.material', value: 'MATERIAL' },
  { label: 'sync_report.entity_types.spu', value: 'SPU' },
  { label: 'sync_report.entity_types.sku', value: 'SKU' },
  { label: 'sync_report.entity_types.sku_attribute', value: 'SKU_ATTRIBUTE' },
];

export const SYNC_REPORT_EVENT_TYPE_OPTIONS = [
  { label: 'sync_report.event_types.goods_changed', value: 'GoodsChanged' },
  { label: 'sync_report.event_types.category_changed', value: 'CategoryChanged' },
  { label: 'sync_report.event_types.category_updated', value: 'CategoryUpdated' },
  { label: 'sync_report.event_types.material_changed', value: 'MaterialChanged' },
  { label: 'sync_report.event_types.material_updated', value: 'MaterialUpdated' },
  { label: 'sync_report.event_types.sku_updated', value: 'SkuUpdated' },
  { label: 'sync_report.event_types.spu_updated', value: 'SpuUpdated' },
  {
    label: 'sync_report.event_types.channel_visibility_changed',
    value: 'ChannelVisibilityChanged',
  },
];

export const SYNC_REPORT_SCHEMA_VERSION_OPTIONS = [
  { label: 'sync_report.schema_versions.v1_0', value: '1.0' },
];

export const SYNC_REPORT_RESULT_OPTIONS = [
  { label: 'sync_report.results.success', value: 'SUCCESS' },
  { label: 'sync_report.results.failure', value: 'FAILURE' },
];

// ============================================================================
// SEARCH CONFIGURATION
// ============================================================================

export const SYNC_REPORT_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'eventType',
    label: 'sync_report.search.event_type',
    type: 'select',
    placeholder: 'sync_report.search.select_event_type',
    options: SYNC_REPORT_EVENT_TYPE_OPTIONS,
  },
  {
    key: 'schemaVersion',
    label: 'sync_report.search.schema_version',
    type: 'select',
    placeholder: 'sync_report.search.select_schema_version',
    options: SYNC_REPORT_SCHEMA_VERSION_OPTIONS,
  },
  {
    key: 'result',
    label: 'sync_report.search.result',
    type: 'select',
    placeholder: 'sync_report.search.select_result',
    options: SYNC_REPORT_RESULT_OPTIONS,
  },
  {
    key: 'entityType',
    label: 'sync_report.search.entity_type',
    type: 'select',
    placeholder: 'sync_report.search.select_entity_type',
    options: SYNC_REPORT_ENTITY_TYPE_OPTIONS,
  },
  {
    key: 'occurredAt',
    label: 'sync_report.search.occurred_at',
    type: 'dateRange',
    range: { startKey: 'dateFrom', endKey: 'dateTo' },
  },
];

// ============================================================================
// TABLE CONFIGURATION
// ============================================================================

export const SYNC_REPORT_TABLE_COLUMNS: TableColumn[] = [
  {
    label: 'sync_report.table.columns.entity_id',
    prop: 'entityId',
    width: 100,
  },
  {
    label: 'sync_report.table.columns.entity_type',
    prop: 'entityType',
    width: 100,
  },
  {
    label: 'sync_report.table.columns.event_type',
    prop: 'eventType',
    width: 180,
    type: 'custom',
    template: 'eventTypeTemplate',
  },
  {
    label: 'sync_report.table.columns.schema_version',
    prop: 'schemaVersion',
    width: 120,
  },
  {
    label: 'sync_report.table.columns.operation',
    prop: 'operation',
    width: 100,
    type: 'custom',
    template: 'operationTemplate',
  },
  {
    label: 'sync_report.table.columns.result',
    prop: 'result',
    width: 100,
    type: 'custom',
    template: 'resultTemplate',
  },
  {
    label: 'sync_report.table.columns.error_reason',
    prop: 'errorReason',
    width: 300,
    type: 'custom',
  },
  {
    label: 'sync_report.table.columns.occurred_at',
    prop: 'occurredAt',
    width: 160,
    type: 'custom',
    template: 'dateTemplate',
  },
];
